import axios from '../../v2/app/services/axiosService';

export default {
  async deleteToken(tokenID, sendAlert) {
    const options = {
      params: {
        send_alert: sendAlert,
      }
    };
    const response = await axios.delete(`/api/oauth-tokens/${tokenID}`, options);
    return response.data;
  },
  async getToken(tokenID) {
    const response = await axios.get(`/api/oauth-tokens/${tokenID}`);
    return response.data;
  },
  async getTokens(userID) {
    const response = await axios.get(`/api/users/${userID}/oauth-tokens`);
    return response.data;
  },
  async getTokensForCurrentUser() { // MLD-4786
    const response = await axios.get(`/api/user/oauth-tokens`);
    return response.data;
  },
}
